import {
  GoogleMap,
  InfoWindow,
  Marker,
  OverlayView,
  Polyline,
  useJsApiLoader,
} from "@react-google-maps/api";
import React, { useCallback, useRef, useState } from "react";
import { Card } from "reactstrap";
import { SpecialEventMapIcon } from "../../assets/designedPickedIcons";
import randomImg1 from "../../assets/fresh-fruits.png";
import randomImg3 from "../../assets/place-dummy-1.png";
import randomImg4 from "../../assets/resturant-detail-bg.png";
import PlaceDetails from "../cards/PlaceDetails";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import NormalEventMapCard from "../cards/NormalEventMapCard";

function MapComponent({
  center,
  containerStyle,
  className,
  bodies,
  userLocation,
  routePath, // 👈 new optional prop
  firstMarkerLabel,
  secondMarkerLabel,
  individualPlaceData,
  allEvents
}) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCRfzq_m5J2Pfw5lV7_7NcWs58orBUZOew",
  });

  const navigateTo = useNavigate();
  const [map, setMap] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState(null);

  const randomImages = [randomImg1, randomImg4, randomImg3];
  const randomImg = useRef(
    randomImages[Math.floor(Math.random() * randomImages?.length)]
  );
  const user = useSelector((s) => s?.user ?? {}, shallowEqual);

  const cleanMapStyle = [
    {
      featureType: "poi", // Points of Interest (restaurants, shops, etc.)
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit", // Bus, train icons
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road", // keep roads visible but simplify
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }], // hide small road icons
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "administrative.locality", // city names
      elementType: "labels.text.fill",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "administrative.province", // state names
      elementType: "labels.text.fill",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "landscape.man_made",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "poi.business", // hide business icons
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi.park", // optional: hide park icons but keep color
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
  ];

  console.log(
    "Route-path",
    routePath,
    user,
    "with user-location",
    userLocation
  );

  const normalizeCoords = (lat, lng) => {
    let latitude = Number(lat);
    let longitude = Number(lng);
    if (Math.abs(latitude) > 90) {
      [latitude, longitude] = [longitude, latitude];
    }
    return { lat: longitude, lng: latitude };
  };

  const onLoad = useCallback(
    (mapInstance) => {
      if (bodies?.length > 0) {
        const bounds = new window.google.maps.LatLngBounds();
        bodies.forEach((item) => {
          const { lat, lng } = item;
          bounds.extend({ lat, lng });
        });
        mapInstance.fitBounds(bounds);
      } else if (routePath?.length > 0) {
        const bounds = new window.google.maps.LatLngBounds();
        routePath.forEach((point) => bounds.extend(point));
        mapInstance.fitBounds(bounds);
      } else if (center) {
        mapInstance.setCenter(center);
        mapInstance.setZoom(12);
      }
      setMap(mapInstance);
    },
    [bodies, center, routePath]
  );

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerClassName={className}
      mapContainerStyle={containerStyle}
      center={center}
      zoom={12}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={{
        styles: cleanMapStyle,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControl: true, // keep this if you want manual zoom
      }}
    >
      {userLocation?.latitude && userLocation?.longitude && (
        <OverlayView
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          position={{
            lat: userLocation.latitude,
            lng: userLocation.longitude,
          }}
        >
          <img
            className="place-map-image"
            height={70}
            width={70}
            alt="User"
            src={user?.profilePicture || randomImg.current}
          />
        </OverlayView>
      )}

  {allEvents?.map((item,idx)=>{
    const {lat,lng}=item;
    if(!item?.isSpecial)
    return (
      <OverlayView
        position={{ lat, lng }}
        key={`normal-event-${idx}`}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      >
       <NormalEventMapCard data={item} key={`normal-event-${item?.name}`}/>
      </OverlayView>
    );
  })}


      {/* Existing place overlays */}
      {bodies?.map((item, idx) => {
        const { lat, lng } = item;
        return (
          <OverlayView
            position={{ lat, lng }}
            key={`place-${idx}`}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <Card
              className="place-map-card cursor-pointer shadow-lg"
              onClick={() => {
                setSelectedPlace({ ...item, lat, lng });
              }}
            >
              <img
                src={item?.photos?.[0] || randomImg.current}
                height={70}
                width={70}
                className="place-map-image"
                alt={item?.name}
              />
              {item?.type === "resturant" && (
                <div className="special-event-icon">
                  <SpecialEventMapIcon size={30} />
                </div>
              )}
            </Card>
          </OverlayView>
        );
      })}

      {/* InfoWindow for selected place */}
      {selectedPlace && (
        <OverlayView
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          position={{
            lat: selectedPlace.lat,
            lng: selectedPlace.lng,
          }}
          onCloseClick={() => setSelectedPlace(null)}
        >
          <PlaceDetails selectedPlace={selectedPlace} randomImg={randomImg} />
        </OverlayView>
      )}

      {/* ✅ Route Polyline (only if routePath exists) */}
      {routePath?.length > 0 && (
        <Polyline
          path={routePath}
          options={{
            strokeColor: "#F19D10",
            strokeOpacity: 0.9,
            strokeWeight: 3,
            clickable: false,
          }}
        />
      )}

      {/* Optional: show start & end markers for route */}
      {routePath?.length > 1 && (
        <>
          <OverlayView
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            position={routePath[routePath.length - 1]}
            onCloseClick={() => setSelectedPlace(null)}
          >
            <PlaceDetails
              randomImg={randomImg}
              disabled={true}
              className={"place-map-detail-card"}
              selectedPlace={individualPlaceData}
            />
          </OverlayView>
          {/* <Marker  label={secondMarkerLabel??"B"} /> */}
        </>
      )}
    </GoogleMap>
  ) : (
    <div>Loading map...</div>
  );
}

export default React.memo(MapComponent);
